import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=426968f6"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('426968f6')) {
      api.createRecord('426968f6', component.options)
    } else {
      api.reload('426968f6', component.options)
    }
    module.hot.accept("./AppLayout.vue?vue&type=template&id=426968f6", function () {
      api.rerender('426968f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/AppLayout.vue"
export default component.exports